import React, {FC, useState, useEffect} from "react"
import moment from "moment"

import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import {H2, Body} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import GenericModal from "@irati/ui/src/GenericModal"
import Button from "@irati/ui/src/Button"
import Form from "@irati/ui/src/Form"
import {Input} from "@irati/ui/src/FormItem"
import adminTracking from "@irati-tracking/admin"
import AbandonModal from "./AbandonModal"

interface Props extends InjectIntl {
  show: boolean
  onClose: () => void
}

const CustomProviderModal: FC<Props> = ({show, onClose, formatMessage}) => {
  const [customProvider, setCustomProvider] = useState<string>()
  const [showModal, setShowModal] = useState(show)
  const [showAbandonModal, setShowAbandonModal] = useState(false)

  const handleSubmit = () => {
    adminTracking.hrisUpsellSetup("admin_dysnc_purchase_no_provider", {action: customProvider, date: moment().format("YYYY-MM-DD")})
    onClose()
  }

  const handleOnReturn = () => {
    setShowAbandonModal(false)
    setShowModal(true)
  }

  const handleOnClose = () => {
    setShowAbandonModal(false)
    onClose()
  }

  const handleOnHide = () => {
    setShowModal(false)
    setShowAbandonModal(true)
  }

  useEffect(() => {
    setShowModal(show)
    setCustomProvider("")
  }, [show])

  return (
    <>
      <GenericModal customWidth={750} hideActions show={showModal} onHide={handleOnHide}>
        <H2 marginBottom={2}>
          <FormattedMessage id="admin.components.integration.directorySync.hris.upsell.customHris.title" />
        </H2>
        <Body maxWidth="100%" marginBottom>
          <FormattedMessage id="admin.components.integration.directorySync.hris.upsell.customHris.subTitle" />
        </Body>
        <Flex maxWidth="350px">
          <Form>
            <Input
              name="customHris"
              placeholder={formatMessage({id: "admin.components.integration.directorySync.hris.upsell.customHris.input.placeholder"})}
              label={formatMessage({id: "admin.components.integration.directorySync.hris.upsell.customHris.input.label"})}
              value={customProvider}
              onChange={(value) => setCustomProvider(value)}
            />
          </Form>
        </Flex>
        <Flex justifyContent="flex-end">
          <Button primary paddingLeft={12} paddingRight={12} disabled={!customProvider} onClick={handleSubmit}>
            <FormattedMessage id="admin.components.integration.directorySync.hris.upsell.customHris.submit" />
          </Button>
        </Flex>
      </GenericModal>
      <AbandonModal show={showAbandonModal} upsell onClose={handleOnClose} onReturn={handleOnReturn} />
    </>
  )
}

export default injectIntl(CustomProviderModal)
